import { useState, useEffect } from 'react';
import { Button } from 'components/Button';
import { PolicyInformation } from 'models/PolicyInformation';
import { getIntegrityPolicy } from 'services/ApiCheckoutPageService';
import Markdown from 'components/Shared/Markdown';
import { Spinner } from 'components/Shared/Loader';
import { rm } from 'utils';
import styles from './integrityPolicyModal.scss';

interface OwnProps {
  onClose: () => void;
}

const IntegrityPolicyModal = ({ onClose }: OwnProps) => {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState<PolicyInformation>();

  useEffect(() => {
    getIntegrityPolicy()
      .then(policy => {
        setLoading(false);
        setPolicy(policy);
      })
      .catch(() => {
        setLoading(false);
        setPolicy({
          title: rm('dialogpopup_defaulttitle'),
          component: { tag: 'span', content: rm('error_generic_short') }
        });
      });
  }, []);

  return (
    <Spinner loading={loading} className={styles.spinner}>
      {policy && (
        <>
          <h2 className={styles.policyTitle}>{policy.title}</h2>
          <div className={styles.content}>
            <Markdown {...policy.component} />
          </div>
        </>
      )}
      <Button onClick={onClose} appearance="whitePill">
        {rm('shared_button_close')}{' '}
      </Button>
    </Spinner>
  );
};

export default IntegrityPolicyModal;
